import { array, boolean, nullable, number, record, string, type, union, unknown } from 'superstruct';
import { CartItem } from './item';
export const CartAttributes = record(string(), nullable(union([
    number(),
    string()
])));
export const CartLevelDiscountApplication = unknown();
export const Cart = type({
    token: string(),
    note: nullable(string()),
    attributes: CartAttributes,
    original_total_price: number(),
    total_price: number(),
    total_discount: number(),
    total_weight: number(),
    item_count: number(),
    items: array(CartItem),
    requires_shipping: boolean(),
    currency: string(),
    items_subtotal_price: number(),
    cart_level_discount_applications: array(CartLevelDiscountApplication)
});
